import { environment } from "src/environments/environment";

/**
 * Global constant for default configurations
 */
export const config: any = []

/**
 * Styles
 */

//navbar
config["css_style_properties"] = [
  //colors
  //radius
  { name: "default_radius", value: "8px" },
  { name: "dropdown_radius", value: "5px" },
  { name: "card_radius", value: ".375rem" },
  { name: "field_radius", value: "8px" },
  { name: "button_radius", value: "15px" },
  //Other colors

  //sizes
  { name: "border:", value: "1px solid rgba(0,0,0,.05)" },

  //effects
  { name: "shadow-xs", value: "1px 1px 2px 0px #0000003b" },
  { name: "shadow-sm", value: "3px 3px 4px 0px #0000003b" },
  { name: "shadow-md", value: "0 50px 100px rgb(50 50 93 / 10%), 0 15px 35px rgb(50 50 93 / 15%), 0 5px 15px rgb(0 0 0 / 10%)" },
  { name: "shadow:", value: "0 0 2rem 0 rgba(136,152,170,.15)" },
  { name: "shadow-fb", value: "0 1px 2px rgba(0, 0, 0, 0.2)" },

  //Fonts
  { name: "default-font-size", value: "16px" },
  { name: "primary-font", value: "Montserrat" },
  { name: "secondary-font", value: "Karla" },
  { name: "last-font", value: "Poppins" },

  { name: "font-thin", value: 100 },
  { name: "font-extra-light", value: 200 },
  { name: "font-light", value: 300 },
  { name: "font-regular", value: 400 },
  { name: "font-medium", value: 500 },
  { name: "font-semibold", value: 600 },
  { name: "font-bold", value: 700 },
  { name: "font-extra-bold", value: 800 },
  { name: "font-black", value: 900 },

  //transitions
  { name: "transition-basic", value: "all ease 0.3s" },
]

//app
config["app_title"] = "Jamar Admin - " + environment.environment;
config["app_version"] = "2021.1.0";
config["app_developer"] = "Jamar";
config["app_developer_link"] = "https://www.jamar.com";

//Default routes
config["route_on_login"] = "/home";
config["route_on_cant_register"] = "/dashboard";
config["route_on_forbidden"] = "/403";

//Default configuration
config["users_can_unlock_their_own_user"] = true;
config["users_can_register_themselves"] = false;

//Meta tags
config["meta_description"] = `We are facilitators of the raising of projects and ideas in digital environments. Through the strategic development of marketing, branding, creative design, and product development and software strategies, we help your company have a digital impact that is agile and innovative. We provide advice for companies, projects and ideas that already have a logistical route outlined in which we can find improvement options, both in branding, marketing, software and the business model in general.`
config["meta_keywords"] = ["graphic", "design", "software", "marketing", "web", "apps", "branding", "innovation", "creation"]


